import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=77c2d668"
import script from "./page-header.vue?vue&type=script&lang=js"
export * from "./page-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77c2d668')) {
      api.createRecord('77c2d668', component.options)
    } else {
      api.reload('77c2d668', component.options)
    }
    module.hot.accept("./page-header.vue?vue&type=template&id=77c2d668", function () {
      api.rerender('77c2d668', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/general/page-header.vue"
export default component.exports